import { MdOutlineLightMode, MdOutlineDarkMode, MdOutlineDesktopWindows } from "react-icons/md";
import { setThemePreference, useTheme } from "lib/theme";

const OPTIONS = [
  { value: "light", title: "Light mode", Icon: MdOutlineLightMode },
  { value: "system", title: "System mode", Icon: MdOutlineDesktopWindows },
  { value: "dark", title: "Dark mode", Icon: MdOutlineDarkMode },
];

/** Kuest ThemeSelector: three 28px icon buttons, the active one in the primary variant. */
export default function ThemeSelector({ className = "" }) {
  const { preference } = useTheme();
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`} role="radiogroup" aria-label="Theme">
      {OPTIONS.map(({ value, title, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            title={title}
            aria-label={title}
            onClick={(event) => {
              event.stopPropagation();
              setThemePreference(value);
            }}
            className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-sm transition-colors focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 ${
              active
                ? "bg-primary text-primary-foreground hover:bg-primary/90"
                : "border border-border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:hover:bg-input/50"
            }`}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
